import { render, staticRenderFns } from "./BudgetsSecondNavDrawer.vue?vue&type=template&id=025df3d3&scoped=true"
import script from "./BudgetsSecondNavDrawer.vue?vue&type=script&lang=js"
export * from "./BudgetsSecondNavDrawer.vue?vue&type=script&lang=js"
import style0 from "./BudgetsSecondNavDrawer.vue?vue&type=style&index=0&id=025df3d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025df3d3",
  null
  
)

export default component.exports